import React, { useEffect, useState } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import axios from "axios";
import { trackBus, server } from "../../server";

const containerStyle = {
  width: "100%",
  height: "90vh",
};

export const busMapCoordinates = {
  lat: 23.3,
  lng: 85.35,
};

const TrackBus = () => {
  const [buses, setBuses] = useState([]);
  const [clickedBus, setClickedBus] = useState(null);
  const [busAddress, setBusAddress] = useState("");
  const [driverInfo, setDriverInfo] = useState(null); // ← store driver info
  const [driverLoading, setDriverLoading] = useState(false);

  console.log(driverInfo);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyCDcx6y5_bx16MY_eM1fDxxHIuteHR_VsM",
  });

  useEffect(() => {
    const fetchBusData = () => {
      axios.get(trackBus).then((res) => {
        if (res.data.successful && res.data.object) {
          setBuses(res.data.object);
        }
      });
    };

    fetchBusData();
    const interval = setInterval(fetchBusData, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (clickedBus) {
      // Reverse geocode address
      const geocoder = new window.google.maps.Geocoder();
      const latlng = {
        lat: parseFloat(clickedBus.latitude),
        lng: parseFloat(clickedBus.longitude),
      };
      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === "OK" && results[0]) {
          setBusAddress(results[0].formatted_address);
        } else {
          setBusAddress("Location not available");
        }
      });

      // Fetch driver details by vehicleNumber
      fetchDriverByVehicleNumber(clickedBus);
    }
  }, [clickedBus?.deviceUniqueId]); // ← only re-fetch when a different bus is clicked

  useEffect(() => {
    if (clickedBus && buses.length > 0) {
      const updatedBus = buses.find(
        (bus) => bus.deviceUniqueId === clickedBus.deviceUniqueId,
      );
      if (updatedBus) {
        setClickedBus(updatedBus);
      }
    }
  }, [buses]);

  // Extract vehicle number from bus name e.g. "Bus 3 (JH01DK7604)" → "JH01DK7604"
  const getVehicleNumber = (bus) => {
    return bus?.name?.replace(/\s+/g, "").split("(")[0] || null;
  };

  const fetchDriverByVehicleNumber = async (bus) => {
    const vehicleNumber = getVehicleNumber(bus);
    if (!vehicleNumber) {
      console.warn("Vehicle number not found in bus name:", bus?.name);
      setDriverInfo(null);
      return;
    }

    setDriverLoading(true);
    setDriverInfo(null);

    try {
      const response = await axios.post(
        `${server}/driver_details_by_driverId_mongodb`,
        { vehicleNumber: vehicleNumber }, // ← send vehicleNumber
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        },
      );

      const driverDetails = response.data["body-json"]?.body;
      if (!driverDetails) {
        console.warn("Driver details not found for vehicle:", vehicleNumber);
        setDriverInfo(null);
        return;
      }

      setDriverInfo(driverDetails); // ← store in state
    } catch (error) {
      console.error("Error fetching driver details:", error);
      setDriverInfo(null);
    } finally {
      setDriverLoading(false);
    }
  };

  const handleBusClick = (bus) => {
    setClickedBus(bus);
    setDriverInfo(null); // reset previous driver info on new click
  };

  const getBusIcon = (bus) => {
    if (!isLoaded || !window.google) return null;
    const isSelected = clickedBus?.deviceUniqueId === bus.deviceUniqueId;
    const isMoving = bus.attributes.motion;

    let url = "/assets/images/bus-icon.png";
    if (isSelected) {
      url = "/assets/images/bus-icon-red.png";
    } else if (isMoving) {
      url = "/assets/images/bus-icon-green.png";
    }

    return {
      url,
      scaledSize: new window.google.maps.Size(40, 40),
      anchor: new window.google.maps.Point(20, 20),
    };
  };

  return (
    <div id="db-wrapper">
      <main id="page-content">
        <div className="">
          {isLoaded && (
            <>
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={busMapCoordinates}
                zoom={11}
              >
                {buses.map((bus) => (
                  <Marker
                    key={bus.id}
                    position={{
                      lat: parseFloat(bus.latitude),
                      lng: parseFloat(bus.longitude),
                    }}
                    icon={getBusIcon(bus)}
                    onClick={() => handleBusClick(bus)}
                  />
                ))}
              </GoogleMap>

              {clickedBus && (
                <div className="position-fixed top-10 w-25 bg-white p-3 rounded-4 z-5 end-0 me-4 mt-8">
                  <div>
                    <i
                      onClick={() => {
                        setClickedBus(null);
                        setDriverInfo(null);
                      }}
                      className="bi bi-x-lg fs-4 cursor-pointer"
                    ></i>
                  </div>

                  <div className="text-center">
                    <img
                      src="/assets/images/bus.png"
                      alt="School Bus"
                      className="mx-auto rounded-4 object-fit-cover shadow"
                      width="120"
                      height="80"
                      style={{ marginTop: -100 }}
                    />

                    <h6 className="text-secondary text-uppercase fs-6 fw-normal m-0 mb-1 lh-1">
                      Track School Bus in Real-Time
                    </h6>
                    <p className="text-dark fw-medium fs-4 mb-2 lh-1">
                      Live Tracking for Bus{" "}
                      <span className="text-primary">
                        {clickedBus.name.replace(/\s+/g, "").split("(")[0]}
                        {driverInfo?.busNumber && (
                          <> ({driverInfo?.busNumber})</>
                        )}
                      </span>
                    </p>
                    <p className="text-center px-5 fs-5 lh-1">
                      Get live updates on school bus location, speed, and status
                      — all in one place.
                    </p>

                    <div className="mx-2 mb-1">
                      <div className="row justify-content-center g-1">
                        <div className="col-3">
                          <i className="bi bi-speedometer2 fs-4 text-dark"></i>
                          <div className="fs-5">
                            {Math.round(clickedBus.speed)} Km/hr
                          </div>
                        </div>
                        <div className="col-3">
                          <i className="bi bi-battery-full fs-4 text-dark"></i>
                          <div className="fs-5">
                            {Math.min(clickedBus.attributes.batteryLevel, 100)}%
                          </div>
                        </div>
                        <div className="col-3">
                          <i className="bi bi-key fs-4 text-dark"></i>
                          <div className="fs-5">
                            {clickedBus.attributes.ignition ? "On" : "Off"}
                          </div>
                        </div>
                        <div className="col-4">
                          <i className="bi bi-bus-front fs-4 text-dark"></i>
                          <div className="fs-5">
                            {clickedBus.attributes.motion
                              ? "Moving"
                              : "Stopped"}
                          </div>
                        </div>
                        <div className="col-4">
                          <i className="bi bi-signpost fs-4 text-dark"></i>
                          <div className="fs-5">
                            {(
                              clickedBus.attributes?.todayDistance / 1000
                            ).toFixed(2)}{" "}
                            KMs
                          </div>
                        </div>
                      </div>

                      <div className="mt-4 bg-light py-3 px-4 rounded-4">
                        <div className="d-flex align-items-center">
                          <i className="bi bi-telephone-outbound-fill text-dark fs-3 me-3"></i>
                          <div>
                            <p className="m-0 text-start lh-1 fs-5">
                              Contact Driver
                            </p>
                            <div className="text-start">
                              <h4 className="m-0 fs-5 fw-medium">
                                {driverLoading
                                  ? "..."
                                  : driverInfo?.driverPhoneNumber
                                    ? `(+91) ${driverInfo.driverPhoneNumber}`
                                    : "(+91) N/A"}
                              </h4>
                            </div>
                          </div>
                        </div>

                        {/* Driver Name */}
                        {driverInfo?.driverName && (
                          <div className="d-flex align-items-center mt-2">
                            <i className="bi bi-person-fill text-dark fs-3 me-3"></i>
                            <div>
                              <p className="m-0 text-start lh-sm fs-5">Driver</p>
                              <div className="text-start">
                                <h4 className="m-0 fs-5 lh-1 fw-medium">
                                  {driverInfo.driverName}
                                  <br />({driverInfo?.driverId})
                                </h4>
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="d-flex align-items-center mt-2">
                          <i className="bi bi-telephone-outbound-fill text-dark fs-3 me-3"></i>
                          <div>
                            <p className="m-0 text-start lh-1 fs-5">
                              Contact Helper
                            </p>
                            <div className="text-start">
                              <h4 className="m-0 fs-5 fw-medium">
                                {driverLoading
                                  ? "..."
                                  : driverInfo?.helperPhoneNumber
                                    ? `(+91) ${driverInfo.helperPhoneNumber}`
                                    : "(+91) N/A"}
                              </h4>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex align-items-center mt-2">
                          <i className="bi bi-pin-map-fill text-dark fs-3 me-3"></i>
                          <div>
                            <p className="m-0 text-start lh-1 fs-5 mb-1">
                              Location
                            </p>
                            <div className="text-start">
                              <p className="text-dark fs-5 lh-1 pe-4 m-0">
                                {busAddress}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </main>
    </div>
  );
};

export default TrackBus;
